module.exports = __webpack_public_path__ + "Roboto-Light.c0f6705840e0f24b376f.eot";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Light.eot
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Light.eot
// module chunks = styles